namespace GeniuzPOS.Administration {
    export enum UnlockUserEnum {
        UnlockUser = 0,
        LockUser = 1
    }
    Serenity.Decorators.registerEnumType(UnlockUserEnum, 'GeniuzPOS.Administration.UnlockUserEnum', 'Administration.UnlockUserEnum');
}
